import React from 'react';
import { Typography } from '@creditas/typography';

import { BottomLine } from './headerText.styles';

import { HeaderTextProps } from '../../types/headerText.types';

const HeaderText: React.FC<HeaderTextProps> = (props: HeaderTextProps) => {
  const { text, description } = props;
  return (
    <div>
      <Typography variant={'h5'}>{text}</Typography>
      <BottomLine />
      <Typography className="header-text__desc" variant={'support'}>
        {description}
      </Typography>
    </div>
  );
};

export default HeaderText;
